angular.module("vgresiduos").controller("DmrReportCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `declaracoes/dmr`);
		};
	}
]);
